import { Invoice } from 'types'

export function getInvoiceTotal(invoice: Invoice): number {
  if (invoice.total) {
    return Number(invoice.total)
  }

  return invoice.invoice_lines.reduce((total, item) => {
    return total + Number(item.price)
  }, 0)
}

export function getInvoiceTaxes(invoice: Invoice): number {
  if (invoice.tax) {
    return Number(invoice.tax)
  }

  return invoice.invoice_lines.reduce((total, item) => {
    return total + Number(item.tax)
  }, 0)
}

export function getInvoiceGrandTotal(invoice: Invoice): number {
  return getInvoiceTaxes(invoice) + getInvoiceTotal(invoice)
}
